import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export function uahFromNow () {
	return function (date) {
		return dayjs(date).fromNow();
	};
}
